import * as React from "react";
import { GafOktaManager } from "../../auth/gaf-okta-auth";
import { Redirect } from "react-router-dom";
import { getCustomerIDFromStore, getQueryString, redirectToCCZ } from "../../utils/utils";

export class HomeNotLoggedIn extends React.Component<any, any> {
    state = {
        authenticated: null,
        error: null,
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        const authenticated = GafOktaManager.isAuthenticated;
        this.setState({ authenticated }, () => {
            if (!this.state.authenticated) {
                //GafOktaManager.getRenewToken()
                GafOktaManager.login();
            }
        });
    }

    render() {
        const customerID = getCustomerIDFromStore(true);
        const newRoute = `?customerID=${customerID}`;
        if (GafOktaManager.isAuthenticated && customerID) {
            localStorage.removeItem("skipSessionClear");
            return <Redirect to={newRoute} />;
        } else {
            localStorage.setItem("skipSessionClear", "true");
            const urlParams = new URLSearchParams(window.location.search);
            const provider =
                urlParams.get("provider") || getQueryString("provider", sessionStorage.getItem("requestURL"));
            if (!provider || provider.toLowerCase() !== "okta") {
                if (customerID) {
                    GafOktaManager.getRenewToken();
                } else {
                    if (!window.location.href.match(/payment/gi)) {
                        redirectToCCZ();
                    }
                }
            }
            return null;
        }
    }
}
